export default {
  login: { id: 'login' },
  login_google: { id: 'login_google' },
  social_auth: { id: 'social_auth' },
  authSubtitle: { id: 'auth_subtitle' },
}
